/**
 * Vybavení studia — lokalizovaná verze (CS + EN).
 *
 * Pole `vyrobce` a `typ` jsou sdílená (značky, modely).
 * Pole `category` a `popis` jsou přeložená.
 *
 * Výběr jazyka: použij `getEquipmentData(lang)`.
 * Default export je česká verze (zpětná kompatibilita).
 */

const equipmentListDataCs = [
  {
    category: 'Mikrofony',
    items: [
      {
        vyrobce: 'Neumann',
        typ: 'TLM 103',
        popis: 'Legendární mikrofon – používám převážně na zpěvy, ale je skvělý i na akustiku nebo jako room mic pro bicí',
      },
      {
        vyrobce: 'Townsend/Universal audio',
        typ: 'Sphere L22',
        popis: 'Neuvěřitelný velkomembránový mikrofon. Díky duální kapsly je možný používat jak v mono tak i ve stereo režimu. Zatím nepřekonaný na zpěvy, akustickou kytaru nebo room mic na bicí. Více info zde.',
      },
      {
        vyrobce: 'Shure',
        typ: 'SM57',
        popis: 'Klasika mezi dynamickými mikrofony. Využívám na kytarové zesilovače, snare nebo hi-hat.',
      },
      {
        vyrobce: 'Shure',
        typ: 'SM58',
        popis: 'Klasický dynamický mikrofon na zpěv.',
      },
      {
        vyrobce: 'AKG',
        typ: 'C414',
        popis: 'Velkomembránový kondenzátorový mikrofon. Skvělý na zpěv, akustickou kytaru nebo bicí.',
      },
      {
        vyrobce: 'AKG',
        typ: 'C451',
        popis: 'Malý kondenzátorový mikrofon. Používám na snare, hi-hat nebo akustickou kytaru.',
      },
      {
        vyrobce: 'Sennheiser',
        typ: 'MD421',
        popis: 'Dynamický mikrofon. Používám na toms nebo kytarové zesilovače.',
      },
      {
        vyrobce: 'Sennheiser',
        typ: 'MD441',
        popis: 'Dynamický mikrofon. Používám na zpěv nebo kytarové zesilovače.',
      },
      {
        vyrobce: 'AKG',
        typ: 'D112',
        popis: 'Dynamický mikrofon. Používám na kopák.',
      },
      {
        vyrobce: 'Warm Audio',
        typ: 'WA-84 pair',
        popis: 'Za mně dokonalá kopie tužek od Neumann. Akustická kytara nebo overheady jsou s nimy top.',
      },
      {
        vyrobce: 'sE Electronics',
        typ: 'V Kick',
        popis: 'Dynamický mikrofon na kopák.',
      },
    ],
  },
  {
    category: 'Mikrofonové předzesilovače a převodníky',
    items: [
      {
        vyrobce: 'Universal audio',
        typ: '2x Apollo 8x',
        popis: 'Srdce studia – Zvuková karta s úžasnými preampy a konvertory',
      },
      {
        vyrobce: 'Universal audio',
        typ: 'Apollo Twin',
        popis: 'Ovládání monitorů plus dva další UAD preampy',
      },
      {
        vyrobce: 'Warm audio',
        typ: 'WA273',
        popis: 'Velmi povedená kopie legendárního NEVE 1073 by Warm audio',
      },
      {
        vyrobce: 'ART',
        typ: 'TPSII',
        popis: '2x lampový preamp',
      },
      {
        vyrobce: 'WarmAudio',
        typ: 'WA-2A',
        popis: 'HW optokompresor by warm audio',
      },
      {
        vyrobce: 'Focusrite',
        typ: 'Liquid saffire 56',
        popis: 'Dříve sloužil jako zvukovka dnes už jen jako 8 kanálový převodník na ADAT',
      },
      {
        vyrobce: 'Behringer',
        typ: 'Powerplay HA4000',
        popis: '4 kanálový sluchátkový zesilovač. Celkem máme k dispozici 7 sluchátkových cest.',
      },
    ],
  },
  {
    category: 'Kytarové vybavení',
    items: [
      {
        vyrobce: 'Line 6',
        typ: 'Helix',
        popis: 'Simulace aparátů včetně kolekce impulse response',
      },
      {
        vyrobce: 'Salvation Audio',
        typ: 'MatchVox',
        popis: 'Preamp po vzoru Matchless a VOX',
      },
      {
        vyrobce: 'Salvation Audio',
        typ: 'Rhoadie',
        popis: 'Stará dobrá plexina',
      },
      {
        vyrobce: 'Orange',
        typ: '2×12 kabinet',
        popis: 'S dvěma Celestion Vintage 30',
      },
      {
        vyrobce: 'Coffee audio',
        typ: 'Mocha 112',
        popis: 'https://coffee-audio.com/mocha-112/',
      },
      {
        vyrobce: 'Fender',
        typ: 'Deluxe Reverb 68',
        popis: 'Klasický silverface',
      },
      {
        vyrobce: 'OldStep',
        typ: 'Kopie Mesa Boogie Lone Star',
        popis: 'https://oldstep.cz/',
      },
    ],
  },
  {
    category: 'SW vybavení',
    items: [
      { vyrobce: 'Apple', typ: 'Logic Pro X', popis: 'Srdce studia – DAW od Applu' },
      { vyrobce: 'Universal Audio', typ: '1176LN Limiting Amplifier', popis: 'Populární kompresor používaný na bicí a vokály.' },
      { vyrobce: 'Universal Audio', typ: 'LA-2A Leveling Amplifier', popis: 'Optický kompresor ideální pro vokály.' },
      { vyrobce: 'Universal Audio', typ: 'Pultec EQP-1A', popis: 'Pasivní ekvalizér známý pro své muzikální zkreslení.' },
      { vyrobce: 'Universal Audio', typ: 'Teletronix LA-2A', popis: 'Další verze optického kompresoru.' },
      { vyrobce: 'Universal Audio', typ: 'dbx 160', popis: 'VCA kompresor vhodný pro nástroje s vysokým tranzientním obsahem.' },
      { vyrobce: 'Universal Audio', typ: 'Shadow Hills Mastering Compressor', popis: 'Kombinuje optický a VCA kompresor pro mastering.' },
      { vyrobce: 'Universal Audio', typ: 'EMT 140 Classic Plate Reverb', popis: 'Reverb s charakteristickým "plate" zvukem.' },
      { vyrobce: 'Universal Audio', typ: 'Fairchild Tube Limiter Collection', popis: 'Vintage kompresory používané The Beatles a Pink Floyd.' },
      { vyrobce: 'Universal Audio', typ: 'Galaxy Tape Echo', popis: 'Emulace Roland RE-201 tape delay/spring reverb jednotky.' },
      { vyrobce: 'Slate Digital', typ: 'FG-X Mastering Processor', popis: 'Masteringový procesor.' },
      { vyrobce: 'Slate Digital', typ: 'Virtual Mix Rack', popis: 'Modulární mixážní rack.' },
      { vyrobce: 'Slate Digital', typ: 'Virtual Tape Machines', popis: 'Emulace páskového stroje.' },
      { vyrobce: 'Slate Digital', typ: 'VerbSuite Classics', popis: 'Reverb plugin.' },
      { vyrobce: 'Slate Digital', typ: 'Repeater', popis: 'Delay plugin.' },
      { vyrobce: 'Slate Digital', typ: 'Fresh Air', popis: 'Enhancer.' },
      { vyrobce: 'Slate Digital', typ: 'Virtual Buss Compressors', popis: 'Set buss kompresorů.' },
      { vyrobce: 'Slate Digital', typ: 'FG-2A', popis: 'Optický kompresor.' },
      { vyrobce: 'Slate Digital', typ: 'Custom Opto', popis: 'Optický kompresor.' },
      { vyrobce: 'Slate Digital', typ: 'FG-Stress', popis: 'Emulace Empirical Labs Distressor.' },
      { vyrobce: 'Slate Digital', typ: 'Infinity EQ', popis: 'Equalizer.' },
      { vyrobce: 'iZotope', typ: 'Maximizer', popis: 'Limiter.' },
      { vyrobce: 'iZotope', typ: 'Equalizer', popis: 'Ekvalizér.' },
      { vyrobce: 'iZotope', typ: 'Dynamic EQ', popis: 'Dynamický ekvalizér.' },
      { vyrobce: 'iZotope', typ: 'Vintage Limiter', popis: 'Vintage limiter.' },
      { vyrobce: 'iZotope', typ: 'Exciter', popis: 'Harmonic exciter.' },
      { vyrobce: 'iZotope', typ: 'Imager', popis: 'Stereo imager.' },
      { vyrobce: 'iZotope', typ: 'Master Rebalance', popis: 'Nástroj pro úpravu mixu.' },
      { vyrobce: 'iZotope', typ: 'Low End Focus', popis: 'Nástroj pro úpravu nízkých frekvencí.' },
      { vyrobce: 'iZotope', typ: 'Vocal Assistant', popis: 'Asistent pro zpracování vokálů.' },
      { vyrobce: 'iZotope', typ: 'Pitch Editor', popis: 'Editor ladění.' },
      { vyrobce: 'iZotope', typ: 'Breath Control', popis: 'Kontrola dechu.' },
      { vyrobce: 'iZotope', typ: 'Harmony', popis: 'Harmonizer.' },
      { vyrobce: 'iZotope', typ: 'Dimension', popis: 'Přidání prostoru.' },
      { vyrobce: 'iZotope', typ: 'De-Esser', popis: 'Odstranění sykavek.' },
      { vyrobce: 'iZotope', typ: 'Saturation', popis: 'Saturace.' },
      { vyrobce: 'iZotope', typ: 'Reverb', popis: 'Reverb.' },
      { vyrobce: 'iZotope', typ: 'Delay', popis: 'Delay.' },
      { vyrobce: 'iZotope', typ: 'Gate', popis: 'Gate.' },
      { vyrobce: 'SSL', typ: 'SSL Native Channel Strip', popis: 'Emulace channel stripu.' },
      { vyrobce: 'SSL', typ: 'SSL Native Bus Compressor', popis: 'Buss kompresor.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-EQ 2', popis: 'Ekvalizér.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-Comp', popis: 'Kompresor.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-ValveComp', popis: 'Valve kompresor.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-Saturator', popis: 'Saturátor.' },
    ],
  },
];

const equipmentListDataEn = [
  {
    category: 'Microphones',
    items: [
      {
        vyrobce: 'Neumann',
        typ: 'TLM 103',
        popis: 'Legendary microphone – mainly used for vocals, but excellent on acoustics or as a room mic for drums.',
      },
      {
        vyrobce: 'Townsend/Universal audio',
        typ: 'Sphere L22',
        popis: 'An incredible large-diaphragm microphone. The dual capsule design allows both mono and stereo use. Unbeaten on vocals, acoustic guitar or as a drum room mic. More info here.',
      },
      {
        vyrobce: 'Shure',
        typ: 'SM57',
        popis: 'A classic among dynamic microphones. I use it on guitar amps, snare or hi-hat.',
      },
      {
        vyrobce: 'Shure',
        typ: 'SM58',
        popis: 'Classic dynamic vocal microphone.',
      },
      {
        vyrobce: 'AKG',
        typ: 'C414',
        popis: 'Large-diaphragm condenser microphone. Great on vocals, acoustic guitar or drums.',
      },
      {
        vyrobce: 'AKG',
        typ: 'C451',
        popis: 'Small-diaphragm condenser. I use it on snare, hi-hat or acoustic guitar.',
      },
      {
        vyrobce: 'Sennheiser',
        typ: 'MD421',
        popis: 'Dynamic microphone. I use it on toms or guitar amps.',
      },
      {
        vyrobce: 'Sennheiser',
        typ: 'MD441',
        popis: 'Dynamic microphone. I use it on vocals or guitar amps.',
      },
      {
        vyrobce: 'AKG',
        typ: 'D112',
        popis: 'Dynamic kick drum microphone.',
      },
      {
        vyrobce: 'Warm Audio',
        typ: 'WA-84 pair',
        popis: 'In my opinion the perfect clone of the Neumann pencil mics. Top choice for acoustic guitar or overheads.',
      },
      {
        vyrobce: 'sE Electronics',
        typ: 'V Kick',
        popis: 'Dynamic kick drum microphone.',
      },
    ],
  },
  {
    category: 'Microphone Preamps & Converters',
    items: [
      {
        vyrobce: 'Universal audio',
        typ: '2x Apollo 8x',
        popis: 'The heart of the studio – audio interface with outstanding preamps and converters.',
      },
      {
        vyrobce: 'Universal audio',
        typ: 'Apollo Twin',
        popis: 'Monitor control plus two additional UAD preamps.',
      },
      {
        vyrobce: 'Warm audio',
        typ: 'WA273',
        popis: 'Excellent clone of the legendary Neve 1073 by Warm Audio.',
      },
      {
        vyrobce: 'ART',
        typ: 'TPSII',
        popis: '2-channel tube preamp.',
      },
      {
        vyrobce: 'WarmAudio',
        typ: 'WA-2A',
        popis: 'Hardware optical compressor by Warm Audio.',
      },
      {
        vyrobce: 'Focusrite',
        typ: 'Liquid saffire 56',
        popis: 'Previously the main audio interface, now used as an 8-channel ADAT converter.',
      },
      {
        vyrobce: 'Behringer',
        typ: 'Powerplay HA4000',
        popis: '4-channel headphone amplifier. A total of 7 headphone mixes are available.',
      },
    ],
  },
  {
    category: 'Guitar Equipment',
    items: [
      {
        vyrobce: 'Line 6',
        typ: 'Helix',
        popis: 'Amp modeller with a full impulse response library.',
      },
      {
        vyrobce: 'Salvation Audio',
        typ: 'MatchVox',
        popis: 'Preamp inspired by Matchless and VOX.',
      },
      {
        vyrobce: 'Salvation Audio',
        typ: 'Rhoadie',
        popis: 'Classic plexi-style amp head.',
      },
      {
        vyrobce: 'Orange',
        typ: '2×12 cabinet',
        popis: 'Loaded with two Celestion Vintage 30 speakers.',
      },
      {
        vyrobce: 'Coffee audio',
        typ: 'Mocha 112',
        popis: 'https://coffee-audio.com/mocha-112/',
      },
      {
        vyrobce: 'Fender',
        typ: 'Deluxe Reverb 68',
        popis: 'Classic silverface combo.',
      },
      {
        vyrobce: 'OldStep',
        typ: 'Mesa Boogie Lone Star clone',
        popis: 'https://oldstep.cz/',
      },
    ],
  },
  {
    category: 'Software',
    items: [
      { vyrobce: 'Apple', typ: 'Logic Pro X', popis: "The heart of the studio – Apple's DAW." },
      { vyrobce: 'Universal Audio', typ: '1176LN Limiting Amplifier', popis: 'Popular compressor used on drums and vocals.' },
      { vyrobce: 'Universal Audio', typ: 'LA-2A Leveling Amplifier', popis: 'Optical compressor ideal for vocals.' },
      { vyrobce: 'Universal Audio', typ: 'Pultec EQP-1A', popis: 'Passive equalizer known for its musical coloration.' },
      { vyrobce: 'Universal Audio', typ: 'Teletronix LA-2A', popis: 'Another version of the optical compressor.' },
      { vyrobce: 'Universal Audio', typ: 'dbx 160', popis: 'VCA compressor suited for instruments with high transient content.' },
      { vyrobce: 'Universal Audio', typ: 'Shadow Hills Mastering Compressor', popis: 'Combines optical and VCA compression for mastering.' },
      { vyrobce: 'Universal Audio', typ: 'EMT 140 Classic Plate Reverb', popis: 'Reverb with the characteristic plate sound.' },
      { vyrobce: 'Universal Audio', typ: 'Fairchild Tube Limiter Collection', popis: 'Vintage compressors used by The Beatles and Pink Floyd.' },
      { vyrobce: 'Universal Audio', typ: 'Galaxy Tape Echo', popis: 'Emulation of the Roland RE-201 tape delay/spring reverb unit.' },
      { vyrobce: 'Slate Digital', typ: 'FG-X Mastering Processor', popis: 'Mastering processor.' },
      { vyrobce: 'Slate Digital', typ: 'Virtual Mix Rack', popis: 'Modular mixing rack.' },
      { vyrobce: 'Slate Digital', typ: 'Virtual Tape Machines', popis: 'Tape machine emulation.' },
      { vyrobce: 'Slate Digital', typ: 'VerbSuite Classics', popis: 'Reverb plugin.' },
      { vyrobce: 'Slate Digital', typ: 'Repeater', popis: 'Delay plugin.' },
      { vyrobce: 'Slate Digital', typ: 'Fresh Air', popis: 'Enhancer plugin.' },
      { vyrobce: 'Slate Digital', typ: 'Virtual Buss Compressors', popis: 'Set of buss compressors.' },
      { vyrobce: 'Slate Digital', typ: 'FG-2A', popis: 'Optical compressor.' },
      { vyrobce: 'Slate Digital', typ: 'Custom Opto', popis: 'Optical compressor.' },
      { vyrobce: 'Slate Digital', typ: 'FG-Stress', popis: 'Empirical Labs Distressor emulation.' },
      { vyrobce: 'Slate Digital', typ: 'Infinity EQ', popis: 'Equalizer.' },
      { vyrobce: 'iZotope', typ: 'Maximizer', popis: 'Limiter.' },
      { vyrobce: 'iZotope', typ: 'Equalizer', popis: 'Equalizer.' },
      { vyrobce: 'iZotope', typ: 'Dynamic EQ', popis: 'Dynamic equalizer.' },
      { vyrobce: 'iZotope', typ: 'Vintage Limiter', popis: 'Vintage limiter.' },
      { vyrobce: 'iZotope', typ: 'Exciter', popis: 'Harmonic exciter.' },
      { vyrobce: 'iZotope', typ: 'Imager', popis: 'Stereo imager.' },
      { vyrobce: 'iZotope', typ: 'Master Rebalance', popis: 'Mix adjustment tool.' },
      { vyrobce: 'iZotope', typ: 'Low End Focus', popis: 'Low-frequency shaping tool.' },
      { vyrobce: 'iZotope', typ: 'Vocal Assistant', popis: 'Vocal processing assistant.' },
      { vyrobce: 'iZotope', typ: 'Pitch Editor', popis: 'Pitch editing.' },
      { vyrobce: 'iZotope', typ: 'Breath Control', popis: 'Breath noise control.' },
      { vyrobce: 'iZotope', typ: 'Harmony', popis: 'Harmonizer.' },
      { vyrobce: 'iZotope', typ: 'Dimension', popis: 'Spatial widening.' },
      { vyrobce: 'iZotope', typ: 'De-Esser', popis: 'Sibilance removal.' },
      { vyrobce: 'iZotope', typ: 'Saturation', popis: 'Saturation.' },
      { vyrobce: 'iZotope', typ: 'Reverb', popis: 'Reverb.' },
      { vyrobce: 'iZotope', typ: 'Delay', popis: 'Delay.' },
      { vyrobce: 'iZotope', typ: 'Gate', popis: 'Gate.' },
      { vyrobce: 'SSL', typ: 'SSL Native Channel Strip', popis: 'Channel strip emulation.' },
      { vyrobce: 'SSL', typ: 'SSL Native Bus Compressor', popis: 'Bus compressor.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-EQ 2', popis: 'Equalizer.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-Comp', popis: 'Compressor.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-ValveComp', popis: 'Valve compressor.' },
      { vyrobce: 'SSL', typ: 'SSL Native X-Saturator', popis: 'Saturator.' },
    ],
  },
];

/**
 * Vrátí pole vybavení v požadovaném jazyce.
 * @param {string} lang — 'cs' | 'en' (fallback 'cs')
 */
export const getEquipmentData = (lang) =>
  lang === 'en' ? equipmentListDataEn : equipmentListDataCs;

export { equipmentListDataCs, equipmentListDataEn };

// Zpětná kompatibilita — default export je CS verze.
const equipmentListData = equipmentListDataCs;
export default equipmentListData;